/*
 * Copyright (C) 2025-2026 The Klangmotor Authors (see AUTHORS.MD)
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

package io.peekandpoke.klang.ui.comp

/** The material of a control's cap (KLANG-00337, KLANG-00338): the buttons' and the knobs'. */
enum class KlangFinish {
    Dark,
    Silver,
}
